import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3848dba&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3848dba')) {
      api.createRecord('c3848dba', component.options)
    } else {
      api.reload('c3848dba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3848dba&", function () {
      api.rerender('c3848dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Configuraciones/Discord/index.vue"
export default component.exports